import baseAPI from '@/http'

const router = 'api/usuario/grupo'

export const groupsAPI = {
    update: (configuracao) => baseAPI.put(router, configuracao),
    updateMultiple: (configuracao) => baseAPI.put(`${router}/update-grupo`, configuracao),
    get: () => baseAPI.get(`${router}`),
    getOne: (id) => baseAPI.get(`${router}/${id}`),
    delete: (id) => baseAPI.delete(`${router}/delete-group/${id}`),
    create: (configuracao) => baseAPI.post(router, configuracao),
    getLastGroup: () => baseAPI.get(`${router}/get-Last-grupo`)

}

